<template>
  <NuxtLoadingIndicator color="var(--primary-2)" />
  <Html :dir="head.htmlAttrs.dir">
    <LayoutTheHeader
      isTemplate4
      :route-path="routePath"
      @open-login="openLogin"
    />
    <Auth ref="authRef">
      <template #googleSignin>
        <google />
      </template>
    </Auth>
    <main :class="isHome ? 'pt-[5.5rem]' : 'pt-[3.75rem]'">
      <slot />
    </main>
    <LazyLayoutTheFooterAlAnnabi />
  </Html>
</template>

<script setup lang="ts">
import { provide, ref, watch } from "vue";
const authRef = ref<any>(null);
function openLogin() {
  authRef.value.open();
}
provide("openLogin", openLogin);
const head = useI18nHead();

const localePath = useLocalePath();

const route = useRoute();
const routePath = ref(route.path);
const isProductPage = useIsProductPage();

const isHome = ref(true);

watch(
  () => route.path,
  () => {
    routePath.value = route.path;
    isHome.value = route.path == localePath("/");
  },
  { immediate: true }
);
</script>
